export default {
    setLocale(locale) {
        window.localStorage.setItem('user_locale', locale);
        return window.localStorage.getItem('user_locale');
    },
    
    getLocale() {
        return window.localStorage.getItem('user_locale');
    }
}